import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UserService } from './shared/user.service';
import { User } from './shared/user.model';
import { VariablesService } from '../globalService/variables.service';
import { InfoUserService } from '../info-user/shared/info-user.service';
import { DataTableDirective } from 'angular-datatables';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  add: boolean;
  edit:boolean;
  public tableWidget: any;
  datatable:any;
  listUsers:any[] = [];

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();

  constructor(
    private chRef:ChangeDetectorRef,
    private userService:UserService,
    private _variables: VariablesService,
    private userInfo: InfoUserService,
    private http: HttpClient
  ) {
  }
  getHeader() {
    let token = sessionStorage.getItem('jwt');
    // let publicIp = await this.ipService.getPublicIp();
    // let localIp = await this.ipService.getLocalIp();
    return new HttpHeaders({
      "Authorization": "Bearer " + token,
      "Content-Type": "application/json"
      // "PublicIp": publicIp,
      // "LocalIp": localIp
    })
  }

  private initDatatable(): void {
    //debugger;
    let header = this.getHeader();
    this.userInfo.getUserInfo();
    let idUser = this.userInfo.infoUser.idUser;
    let idEmpresa = this.userInfo.infoUser.company.idAdmEmpresa;

    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      serverSide: true,
      processing: true,
      ordering: false,
      ajax: (dataTablesParameters: any, callback) => {
        let data = { idEmpresa: idEmpresa, idUsuario: idUser };
        let temp = {
          datatable: dataTablesParameters,
          parameter: data
        };
        that.http
          .post<any>(
            `${this._variables.data.urlApi}SegUsuarios/GetUsers`,
            temp, { headers: header }
          ).subscribe(resp => {
            that.listUsers = resp.data
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      }

    };
    this.chRef.detectChanges();
  }
  
  ngOnInit() {
    this.add = false;
    this.edit = false;
    this.initDatatable();
  }

  ngAfterViewInit(): void {
    //debugger
    this.dtTrigger.next(true);
    this.chRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    //debugger
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(true);
    });
  }

  onChangeAdd(action: boolean) {
    //debugger
    this.add = action;
    this.edit = false;
    this.chRef.detectChanges();
    setTimeout(()=>{
      this.initDatatable();
    },5000)
  }

  changeAdd(action:boolean){
    this.add = action;
    this.edit = false;
  }


  onChangeEdit(action:boolean){
    //debugger
    this.edit = action;
    this.add = false;
    this.chRef.detectChanges();
    setTimeout(()=>{
      this.rerender();
    },5000)
    
  }

  public onRowSelected(index: number) {
    
  }

  loadUser(id: number) {
    //debugger
    this.userService.getUserToUpdate(id);
    this.onChangeEdit(true);
  }

}
